// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import type {
  GetMovementTypesData,
  GetMovementTypesResponse,
  GetSeoInfoData,
  GetSeoInfoError,
  GetSeoInfoResponse,
  GetSeoInfoAttractionsData,
  GetSeoInfoAttractionsError,
  GetSeoInfoAttractionsResponse,
  GetStatisticData,
  GetStatisticResponse,
  GetArticlesData,
  GetArticlesResponse,
  GetCountriesListData,
  GetCountriesListResponse,
  GetPopularArticlesData,
  GetPopularArticlesResponse,
  GetAuthorData,
  GetAuthorError,
  GetAuthorResponse,
  GetJournalContentsData,
  GetJournalContentsResponse,
  GetCitiesData,
  GetCitiesError,
  GetCitiesResponse,
  GetCityBySlugData,
  GetCityBySlugError,
  GetCityBySlugResponse,
  GetExperiencesFavoritesListData,
  GetExperiencesFavoritesListResponse,
  RemoveExperienceFromFavoriteData,
  RemoveExperienceFromFavoriteResponse,
  AddExperienceToFavoriteData,
  AddExperienceToFavoriteResponse,
  GetRegionData,
  GetRegionResponse,
  GetSightsData,
  GetSightsResponse,
  CreateReviewData,
  CreateReviewError,
  CreateReviewResponse,
  GetExperienceListData,
  GetExperienceListResponse,
  GetGeoTypeaheadData,
  GetGeoTypeaheadError,
  GetGeoTypeaheadResponse,
  GetArticleBySlugData,
  GetArticleBySlugResponse,
  GetEditorialSectionsData,
  GetEditorialSectionsResponse,
  GetBffV1ExperienceListData,
  GetBffV1ExperienceListResponse,
} from './types.gen';
import { getArticleBySlugResponseTransformer } from './transformers.gen';

export const client = createClient(createConfig());

/**
 * Получение списка экскурсий/туров в избранном
 */
export const getMovementTypes = <ThrowOnError extends boolean = false>(
  options?: Options<GetMovementTypesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetMovementTypesResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/movement-types/ ',
  });
};

/**
 * SEO
 * SEO data
 */
export const getSeoInfo = <ThrowOnError extends boolean = false>(options: Options<GetSeoInfoData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetSeoInfoResponse, GetSeoInfoError, ThrowOnError>({
    ...options,
    url: '/api/seo/v2/{type}_infopage/',
  });
};

/**
 * SEO
 * SEO data
 */
export const getSeoInfoAttractions = <ThrowOnError extends boolean = false>(
  options: Options<GetSeoInfoAttractionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetSeoInfoAttractionsResponse, GetSeoInfoAttractionsError, ThrowOnError>({
    ...options,
    url: '/api/seo/v2/{type}_infopage_attractions/',
  });
};

/**
 * Service statistic
 */
export const getStatistic = <ThrowOnError extends boolean = false>(
  options?: Options<GetStatisticData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetStatisticResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/statistic/',
  });
};

/**
 * Get journal articles
 */
export const getArticles = <ThrowOnError extends boolean = false>(options: Options<GetArticlesData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetArticlesResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/articles/',
  });
};

/**
 * Get countries
 */
export const getCountriesList = <ThrowOnError extends boolean = false>(
  options: Options<GetCountriesListData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetCountriesListResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/articles/countries/',
  });
};

/**
 * Get popular articles
 */
export const getPopularArticles = <ThrowOnError extends boolean = false>(
  options: Options<GetPopularArticlesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetPopularArticlesResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/articles/landing/',
  });
};

/**
 * Authors
 * Journal author
 */
export const getAuthor = <ThrowOnError extends boolean = false>(options: Options<GetAuthorData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetAuthorResponse, GetAuthorError, ThrowOnError>({
    ...options,
    url: '/api/web/v1/authors/{authorId}/',
  });
};

/**
 * Get journal contents
 */
export const getJournalContents = <ThrowOnError extends boolean = false>(
  options: Options<GetJournalContentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetJournalContentsResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/authors/{authorId}/journal-contents/',
  });
};

/**
 * City
 * Cities
 */
export const getCities = <ThrowOnError extends boolean = false>(options?: Options<GetCitiesData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetCitiesResponse, GetCitiesError, ThrowOnError>({
    ...options,
    url: '/api/web/v1/cities/',
  });
};

/**
 * City
 * City info
 */
export const getCityBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetCityBySlugData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetCityBySlugResponse, GetCityBySlugError, ThrowOnError>({
    ...options,
    url: '/api/web/v1/cities/{citySlug}/',
  });
};

/**
 * Получение списка экскурсий/туров в избранном
 */
export const getExperiencesFavoritesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperiencesFavoritesListData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetExperiencesFavoritesListResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/experiences/favorites/',
  });
};

/**
 * Удалить экспериенс из избранного
 */
export const removeExperienceFromFavorite = <ThrowOnError extends boolean = false>(
  options: Options<RemoveExperienceFromFavoriteData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<RemoveExperienceFromFavoriteResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
  });
};

/**
 * Добавить экспериенс в избранное
 */
export const addExperienceToFavorite = <ThrowOnError extends boolean = false>(
  options: Options<AddExperienceToFavoriteData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<AddExperienceToFavoriteResponse, unknown, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
  });
};

/**
 * Get journal articles
 */
export const getRegion = <ThrowOnError extends boolean = false>(options?: Options<GetRegionData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetRegionResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/regions/{region__slug}/',
  });
};

/**
 * Get journal sights
 */
export const getSights = <ThrowOnError extends boolean = false>(options: Options<GetSightsData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetSightsResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v1/sights/',
  });
};

/**
 * Create review for article or sight
 */
export const createReview = <ThrowOnError extends boolean = false>(
  options: Options<CreateReviewData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateReviewResponse, CreateReviewError, ThrowOnError>({
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    url: '/api/web/v1/{pageType}/{articleId}/reviews/',
  });
};

/**
 * Experiences
 * Main page experience list
 */
export const getExperienceList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperienceListData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetExperienceListResponse, unknown, ThrowOnError>({
    ...options,
    url: '/api/web/v2/experiences/',
  });
};

/**
 * Geo Typeahead
 * Get geo suggestions for typeahead
 */
export const getGeoTypeahead = <ThrowOnError extends boolean = false>(
  options: Options<GetGeoTypeaheadData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetGeoTypeaheadResponse, GetGeoTypeaheadError, ThrowOnError>({
    ...options,
    url: '/geo/typeahead/',
  });
};

/**
 * Получить информацию о статье
 * BFF: GET /service/journal/api/bff/v1/article/{slug} — детали статьи, SEO, связанные материалы
 */
export const getArticleBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetArticleBySlugData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetArticleBySlugResponse, unknown, ThrowOnError>({
    ...options,
    responseTransformer: getArticleBySlugResponseTransformer,
    url: '/service/journal/api/bff/v1/article/{slug}',
  });
};

/**
 * get-editorial-sections
 */
export const getEditorialSections = <ThrowOnError extends boolean = false>(
  options?: Options<GetEditorialSectionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetEditorialSectionsResponse, unknown, ThrowOnError>({
    ...options,
    url: '/service/journal/api/bff/v1/editorial-sections',
  });
};

/**
 * Experiences (BFF)
 * Список экскурсий для журнала (BFF), тот же контракт query/response, что и GET /api/web/v2/experiences/
 */
export const getBffV1ExperienceList = <ThrowOnError extends boolean = false>(
  options?: Options<GetBffV1ExperienceListData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetBffV1ExperienceListResponse, unknown, ThrowOnError>({
    ...options,
    url: '/service/journal/api/bff/v1/experiences',
  });
};
